import { createRouter, createWebHistory } from 'vue-router';
import authRouter from '@/modules/principal/router';
import psycologistsOptionsRouter from '@/modules/psycologists-options/router';
import psycologistsConfigurationsRouter from '@/modules/psycologists/configuration/router';
import psycologistsPatientsRouter from '@/modules/psycologists/patients/router';
import psycologistsHomeRouter from '@/modules/psycologists/home/router';
import psycologistsImpactCasesRouter from '@/modules/psycologists/impact-cases/router';
import usersRouter from '@/modules/users/router';
import interviewerRouter from '@/modules/interviewer/router';
import schedulerRouter from '@/modules/appointments/router';
import patientsRouter from '@/modules/patients/router';
import profilePatientRouter from '@/modules/patients/profile/router';
import profilePsycologistsRouter from '@/modules/psycologists/profile/router';
import waitingRoomRouter, { registerDailyMeditationHooks } from '@/modules/waiting-room/router';
import videocallRouter from '@/modules/videocall/router';
import privacyRouter from '@/modules/privacy/router';
import psychologistInvoicingRouter from '@/modules/psycologists/invoicing/router';
import adminInvoicingRouter from '@/modules/admin/invoicing/router';
import adminCustomersRouter from '@/modules/admin/customers/router';
import adminSessionsRouter from '@/modules/admin/sessions/router';
import adminDiscountCodesRouter from '@/modules/admin/discount-codes/router';
import adminCardsMimenteRouter from '@/modules/admin/cards-mimente/router';
import adminAuthorizedPopulationRouter from '@/modules/admin/authorized-population/router';
import reportsRouter from '@/modules/admin/reports/evaluations/router';
import scalesRouter from '@/modules/questionnario-scales/router';
import roiRouter from '@/modules/roi/router';
import adminTenantsConfigurationRouter from '@/modules/admin/tenants-configuration/router';
import adminExtendedLimitRequestsRouter from '@/modules/admin/extended-limit-requests/router';
import dashboardRouter from '@/modules/admin/dashboard/router';
import dashboardPublicRouter from '@/modules/admin/dashboard/router/public';
import adminBalintSessionsRouter from '@/modules/admin/balint-sessions/router';
import adminPsychologistPaymentConceptsRouter from '@/modules/admin/psychologist-payment-concepts/router';
import verifyTokenRouter from '@/modules/verify-token/router'
import { isLinkedinInsightLoaded, loadLinkedinInsight } from '@/utils/linkedinInsight'

import voicesOfChangeRouter from '@/modules/voices-of-change/router';
const routes = [
  verifyTokenRouter,
  {
    path: "/",
    ...authRouter,
  },
  {
    path: "/roi",
    ...roiRouter,
  },
  {
    path: "/patients",
    ...patientsRouter,
  },
  {
    path: "/psycologists",
    ...psycologistsOptionsRouter,
  },
  {
    path: "/psycologists/configurations",
    ...psycologistsConfigurationsRouter,
  },
  {
    path: "/psycologists/patients",
    ...psycologistsPatientsRouter,
  },
  {
    path: "/psycologists/home",
    ...psycologistsHomeRouter,
  },
  {
    path: "/psycologists/impact-cases",
    ...psycologistsImpactCasesRouter,
  },
  {
    path: "/f-users",
    ...usersRouter,
  },
  {
    path: "/interviewer",
    ...interviewerRouter,
  },
  {
    path: "/schedule-appointment",
    ...schedulerRouter,
  },
  {
    path: "/profile-patient",
    ...profilePatientRouter,
  },
  {
    path: "/profile-psychologist",
    ...profilePsycologistsRouter,
  },
  {
    path: "/waiting-room",
    ...waitingRoomRouter
  },
  {
    path: '/video',
    ...videocallRouter
  },
  {
    path: '/privacy',
    ...privacyRouter
  },
  {
    path: '/psycologists/invoicing',
    ...psychologistInvoicingRouter
  },
  {
    path: '/admin/invoicing',
    ...adminInvoicingRouter
  },
  {
    path: '/admin/customers',
    ...adminCustomersRouter
  },
  {
    path: '/admin/sessions',
    ...adminSessionsRouter
  },
  {
    path: '/admin/discount-codes',
    ...adminDiscountCodesRouter
  },
  {
    path: '/admin/business-card',
    ...adminCardsMimenteRouter
  },
  {
    path: '/admin/authorized-population',
    ...adminAuthorizedPopulationRouter
  },
  {
    path: '/admin/reports',
    ...reportsRouter
  },
  {
    path: '/admin/tenants-configuration',
    ...adminTenantsConfigurationRouter
  },
  {
    path: '/admin/extended-limit-requests',
    ...adminExtendedLimitRequestsRouter
  },
  {
    path: '/scales',
    ...scalesRouter
  },
  {
    path: '/voices-of-change',
    ...voicesOfChangeRouter
  },
  {
    path: '/dashboard',
    ...dashboardRouter
  },
  {
    ...dashboardPublicRouter
  },
  {
    path: '/balint-session',
    ...adminBalintSessionsRouter
  },
  {
    path: '/admin/psychologist-payment-concepts',
    ...adminPsychologistPaymentConceptsRouter
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    const getMain = () => document.getElementById('main_content')

    const getScrollParent = (el) => {
      let node = el?.parentElement
      while (node && node !== document.documentElement) {
        const style = window.getComputedStyle(node)
        const oy = style.overflowY
        const scrollable =
          (oy === 'auto' || oy === 'scroll' || oy === 'overlay') &&
          node.scrollHeight > node.clientHeight + 1
        if (scrollable) return node
        node = node.parentElement
      }
      const main = getMain()
      if (main && main.scrollHeight > main.clientHeight + 1) return main
      return null
    }

    const resetScroll = () => {
      const scroll = getMain()
      if (scroll) {
        scroll.scrollTop = 0
      }
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }

    const scrollToHash = (hash) => {
      let el = null
      try {
        el = document.querySelector(hash)
      } catch (_) {
        return false
      }
      if (!el) return false

      const offset = 24
      const scroller = getScrollParent(el)
      if (scroller) {
        const top =
          el.getBoundingClientRect().top -
          scroller.getBoundingClientRect().top +
          scroller.scrollTop -
          offset
        // behavior:'smooth' no mueve #main_content en este layout
        scroller.scrollTop = Math.max(0, top)
        return true
      }

      el.scrollIntoView({ behavior: 'auto', block: 'start' })
      return true
    }

    if (savedPosition) {
      return savedPosition
    }

    // Anclas (#seccion): no resetear a 0; scrollear al título en el contenedor real
    if (to.hash) {
      return new Promise((resolve) => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            const ok = scrollToHash(to.hash)
            // Reintento por si el layout aún no midió el overflow
            if (!ok) {
              setTimeout(() => scrollToHash(to.hash), 100)
            }
            resolve(ok ? false : { top: 0 })
          }, 50)
        })
      })
    }

    // Cambio de ruta sin hash: volver arriba (limpia hash huérfano de otro artículo)
    resetScroll()
    requestAnimationFrame(resetScroll)
    return { top: 0 }
  }
})

registerDailyMeditationHooks(router)

// LinkedIn Insight Tag: solo en rutas con meta.marketing. Un script cargado no se
// puede descargar, así que al salir a una ruta de plataforma se fuerza recarga completa.
router.beforeEach((to) => {
  if (isLinkedinInsightLoaded() && !to.meta.marketing) {
    window.location.assign(to.fullPath)
    return false
  }
})

router.afterEach((to, from, failure) => {
  // Navegación cancelada: el usuario sigue en la ruta anterior, no cargar
  if (!failure && to.meta.marketing) loadLinkedinInsight()
})

export default router
